import {LogLevelAwareConfig} from '../log-level-aware-config';

/**
 * Abstract logger appender config
 */
export abstract class LoggerAppenderConfig extends LogLevelAwareConfig {
  /**
   * Is Appender enabled
   */
  enabled: boolean = true;
}
